export default __webpack_public_path__ + "static/media/Death's Door.2a97218a.jpg";